export const newSourceMappingSchema = {
  title: 'Source Mapping',
  type: 'object',
  required: ['mapping', 'dealer_id'],
  properties: {
    mapping: { type: 'string', title: 'Mappings' },
    dealer_id: { type: 'string' },
  },
};

export const step1Schema = {
  title: 'Source Mapping',
  type: 'object',
  required: ['dealer_id'],
  properties: {
    mapping: { type: 'string', title: 'Mappings' },
    dealer_id: { type: 'string' },
  },
};

export const uiSchema = {
  mapping: {
    'ui:widget': 'textarea',
  },
  dealer_id: { 'ui:widget': 'hidden' },
};
